/** Session cache for portal → organisation lookups (App remounts / slug rewrites). */

const cache = new Map();

export const getCachedOrgLookup = (id) => {
  if (!id) return null;
  return cache.get(String(id).toLowerCase()) || null;
};

export const setCachedOrgLookup = (id, payload) => {
  if (!id || !payload) return;
  const key = String(id).toLowerCase();
  cache.set(key, payload);
  if (payload.portalAlias) {
    cache.set(String(payload.portalAlias).toLowerCase(), payload);
  }
  if (payload.id) {
    cache.set(String(payload.id).toLowerCase(), payload);
  }
};

export const clearOrgLookupCache = () => {
  cache.clear();
};
